import React, { Dispatch, createContext, useContext } from 'react'
import useCFDHWAgent from 'views/CustomerFacingDisplay/hardwareAgent/useCFDHWAgent'
import { CustomerFacingActionType } from '../reducer/CustomerFacingActionType'
import { CustomerFacingDisplayState } from '../reducer/Interface'
import useCustomerFacingDisplayReducer from '../reducer/CFDReducer'

export type ICFDHWAgent = ReturnType<typeof useCFDHWAgent>

type ICFDContext = CustomerFacingDisplayState & {
    dispatch: Dispatch<CustomerFacingActionType>
} & ICFDHWAgent
export const CustomerFacingDisplayContext = createContext<ICFDContext>(
    {} as ICFDContext,
)

export const useCustomerFacingDisplayContext = () => {
    const context = useContext(CustomerFacingDisplayContext)

    if (!context) {
        throw new Error(
            'CustomerFacingDisplayContext must be used within an CustomerFacingDisplayProvider',
        )
    }

    return context
}

const CustomerFacingDisplayProvider = ({
    children,
}: {
    children: React.ReactNode
}) => {
    const { state, dispatch } = useCustomerFacingDisplayReducer()
    const cfdHook = useCFDHWAgent(state.hwAgentUrl ?? '')

    return (
        <CustomerFacingDisplayContext.Provider
            value={{
                ...state,
                ...cfdHook,
                dispatch,
            }}
        >
            {children}
        </CustomerFacingDisplayContext.Provider>
    )
}

export default CustomerFacingDisplayProvider
